import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const Base = resolve => require(['@/pages/base.vue'], resolve);
const Login = resolve => require(['@/pages/login.vue'], resolve);
const Register = resolve => require(['@/pages/register.vue'], resolve);
const RegInfo = resolve => require(['@/pages/registerinfo.vue'], resolve);
const Reset = resolve => require(['@/pages/reset.vue'], resolve);
const LoginRegiser = resolve => require(['@/pages/login-register.vue'], resolve);
const Set = resolve => require(['@/pages/set.vue'], resolve);
const Sub = resolve => require(['@/pages/subregister.vue'], resolve);
const Product = resolve => require(['@/pages/product.vue'], resolve);
const NotFound = resolve => require(['@/pages/notFound.vue'], resolve);
const route = [
    {
        path: '',
        component: Base,
        children: [
            {
                path: '',
                component: LoginRegiser,
                children: [
                    {
                        path: '/login',
                        name: 'login',
                        component: Login
                    },
                    {
                        path: '/register',
                        name: 'register',
                        component: Register
                    },
                    {
                        path: '/reset',
                        name: 'reset',
                        component: Reset
                    },
                    {
                        path: '',
                        component: Login,
                        redirect: { name: 'login' },
                    },
                ]
            },
            {
                path: '/registerinfo',
                name: 'regInfo',
                component: RegInfo
            },
            {
                path: '/set',
                name: 'set',
                component: Set
            },
            {
                path: '/subregister',
                name: 'sub',
                component: Sub
            }
        ]
    },
    {
        path: '/product',
        component: Product,
    },
    {
        path: '/userinfo',
        component: () => import('@/pages/userinfo/userinfo.vue'),
        children: [
            {
                path: 'user',
                component: () => import('@/pages/userinfo/content.vue'),
                name: 'userinfo'
            },
            {
                path: 'message',
                component: () => import('@/pages/userinfo/message.vue'),
                name: 'message'
            },
            {
                path: '',
                redirect: { name: 'userinfo' }
            }
        ]
    },
    {
        path: "/404",
        name: "notFound",
        component: NotFound
    }, {
        path: "*",
        redirect: "/404"
    }
]

export default new Router({
    mode: 'history',
    routes: route,
})



// WEBPACK FOOTER //
// ./src/router/index.js